import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    roles: [],
    routes: [],
    menus: [],
    // 性别选择器
    genderList: [
      { id: 0, name: '保密', checked: true },
      { id: 1, name: '男' },
      { id: 2, name: '女' },
    ],
    qqRoot: [
      {
        login_qq: 2885269519,
        pinyin: 'jinan',
        zh: '济南',
      },
      {
        login_qq: 2885267978,
        pinyin: 'qingdao',
        zh: '青岛',
      },
      {
        login_qq: 2885267821,
        pinyin: 'weihai',
        zh: '威海',
      },
      {
        login_qq: 2885266928,
        pinyin: 'yantai',
        zh: '烟台',
      },
      {
        login_qq: 2885263282,
        pinyin: 'jining',
        zh: '济宁',
      },
      {
        login_qq: 2885262610,
        pinyin: 'taian',
        zh: '泰安',
      },
      {
        login_qq: 2885261972,
        pinyin: 'weifang',
        zh: '潍坊',
      },
      {
        login_qq: 2885261886,
        pinyin: 'binzhou',
        zh: '滨州',
      },
      {
        login_qq: 2885261585,
        pinyin: 'dongying',
        zh: '东营',
      },
      {
        login_qq: 2885260851,
        pinyin: 'liaocheng',
        zh: '聊城',
      },
      {
        login_qq: 2885260703,
        pinyin: 'dezhou',
        zh: '德州',
      },
      {
        login_qq: 2885260620,
        pinyin: 'heze',
        zh: '菏泽',
      },
      {
        login_qq: 2885257167,
        pinyin: 'zibo',
        zh: '淄博',
      },
      {
        login_qq: 2885255825,
        pinyin: 'linyi',
        zh: '临沂',
      },
      {
        login_qq: 2885255787,
        pinyin: 'rizhao',
        zh: '日照',
      },
      {
        login_qq: 2885255726,
        pinyin: 'zaozhuang',
        zh: '枣庄',
      },
      {
        login_qq: 2885255115,
        pinyin: 'shengji',
        zh: '省级',
      },
      {
        login_qq: 2885281571,
        pinyin: 'ceshi',
        zh: '测试账号',
      },
    ],
    userInfo: {},
    wordFunc: [{ id: 1, name: '头像框功能' }],
    dataList: [
      { name: '岗位查询类', value: 0 },
      { name: '专业查询类', value: 1 },
    ],
    // 考试分类
    subCategory: [],
    // 菜单树
    areaTree: [],
    // 文件类型后缀
    extension: [],
  },
  mutations: {
    SET_ROLES(state, value) {
      state.roles = value
    },
    SET_ROUTES(state, value) {
      state.routes = value
    },
    SET_MENUS(state, value) {
      state.menus = value
    },
    SET_USER_INFO(state, value) {
      state.userInfo = value
    },
    SET_SUB_CATEGORY(state, value) {
      state.subCategory = value
    },
    SET_AREA_TREE(state, value) {
      state.areaTree = value
    },
  },
  getters: {
    ROLES: (state) => {
      return state.roles
    },
    Routes: (state) => {
      return state.routes
    },
    Menus: (state) => {
      return state.menus
    },
    genderList: (state) => {
      return state.genderList
    },
    userInfo: (state) => {
      return state.userInfo
    },
    qqRoot: (state) => {
      return state.qqRoot
    },
    wordFunc: (state) => {
      return state.wordFunc
    },
    autoDataList: (state) => {
      return state.dataList
    },
    subCategory(state) {
      return state.subCategory
    },
    areaTree(state) {
      return state.areaTree
    },
  },
})

export default store
